import {endpoint} from "../services/API"
import VueCookies from 'vue-cookies'
import version from "../services/version"

let api=new endpoint("token");
export default {
    namespaced:true,
    state:{
        identity:{
            token:"",
            type:"",
            name:"",
            displayName:""
         },
         options:{
            showDeleteOption:false
         },
        // meta:{
        //     siteName:"Kerala Hockey",
        //     baseUrl:"https://localhost:44310",
        //     apiUrl:"https://localhost:44310/api",
        //     version:version,
        //     forceHttps:false,
        //     initComplete:false
        // },
        // defaults:{
        //     profileImage:"https://localhost:44310/Content/Images/profile.png"
        // },
        meta:{
            siteName:"Kerala Hockey",
            baseUrl:"https://registrations.keralahockeyonline.com",
            apiUrl:"https://registrations.keralahockeyonline.com/api",
            version:version,
            forceHttps:true,
            selfHost:true,
            initComplete:false
        },
        defaults:{
            profileImage:"https://registrations.keralahockeyonline.com/Content/Images/profile.png",//"https://localhost:44310/Content/Images/profile.png"
        }
    },
    mutations:{
        login(state,identity){
            state.identity=identity;
        },
        logout(state){
            state.identity={
                token:"",
                type:""
            };
        },
        toggleDelete(state,show){
            state.options.showDeleteOption=show
        },
        initCompleted:function(state){
            state.meta.initComplete=true;
        }
    },
    actions:{
        login({commit},credentials){
           return api.post(credentials).then(x=>{
               var identity=x.identity;
               identity.token=x.token;
                commit("login",identity);
                return Promise.resolve(x.token);
            });
        },
        logout({commit}){
           return api.delete().then(function(){
                commit("logout");
            }).catch(function(){
                commit("logout");
            });
        },
        async tryRestoreIdentity({state,commit}){
            if(state.meta.initComplete)
                return;

            var token=VueCookies.get("__auth");
            console.log("inititate restore");
            if(token){
                try {
                    var response= await api.get({},{authorization:"Bearer "+token});
                    var identity=response.identity;
                    identity.token=response.token;
                     commit("login",identity);
                     commit("initCompleted");
                     return response.token;
                } catch (error) {
                    console.log(error);
                    commit("initCompleted");
                    throw error;
                }
            }
            else{
                commit("initCompleted");
                throw {feedback:"No active session"};
            }
        }
    }
}